export default "__VITE_ASSET__DKXl8c2A__"